// extracted by mini-css-extract-plugin
module.exports = {"details":"OrdersByIBOLegacy_details__2SVu_","iboListItem":"OrdersByIBOLegacy_iboListItem__3l2sB","noSelection":"OrdersByIBOLegacy_noSelection__EIPlY"};